import { useMemo, forwardRef } from "react";
import { bool, number, oneOf, oneOfType, string } from "prop-types";
import { NumericFormat } from "react-number-format";

export const CellInputReadonlyValue = forwardRef(({
  value,
  prefix,
  suffix,
  decimalScale,
  fixedDecimalScale,
  americanFormat,
  alignContent,
  ...containerProps
}, ref) => {
  
  const isValueText = useMemo(() => (
    value !== undefined && isNaN(Number(value)) && value !== null
  ), [value]);
  
  return <span
    ref={ref}
    style={{ textAlign: alignContent }}
    {...containerProps}
  >
    {
      isValueText
        ? `${prefix || ""}${value}${suffix || ""}`
        : <NumericFormat
          value={value}
          displayType="text"
          valueIsNumericString={!isNaN(Number(value))}
          thousandSeparator={americanFormat ? "," : " "}
          decimalSeparator="."
          decimalScale={decimalScale}
          fixedDecimalScale={fixedDecimalScale}
          prefix={prefix}
          suffix={suffix}
        />
    }
  </span>
})

CellInputReadonlyValue.propTypes = {
  value: oneOfType([number, string]),
  americanFormat: bool,
  className: string,
  decimalScale: number,
  fixedDecimalScale: bool,
  prefix: string,
  suffix: string,
  alignContent: oneOf(["left", "center", "right"]),
}